import { createClient } from '@supabase/supabase-js'

const supabaseUrl = 'https://nmhyshwokervusvnubjk.supabase.co'
const supabaseKey =
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im5taHlzaHdva2VydnVzdm51YmprIiwicm9sZSI6ImFub24iLCJpYXQiOjE3Njg1NTkwNTksImV4cCI6MjA4NDEzNTA1OX0.yqOOK6iHgk99CJ_FterpVm8GfDe1q6Ce4m4fqhIUDzI'

export const supabase = createClient(supabaseUrl, supabaseKey)
